import View from './View';

export { default as View, getCornerLogoStyles } from './View';

export default View;
